import { size } from 'lodash/fp';
import React, { FC } from 'react';
import { AutoSizer } from 'react-virtualized';
import { Legend, Pie, PieChart, Tooltip } from 'recharts';

import { ChartCard } from '../ChartCard';
import { TooltipRenderer } from './common';

type PieChartCardProps = {
  data: Array<Record<string, any>>;
  fill: string;
  isPending?: boolean;
  dataKey: string;
  nameKey: string;
  title: string;
  emptyTitle: string;
};

const PieChartCard: FC<PieChartCardProps> = ({
  data,
  isPending,
  fill,
  title,
  emptyTitle,
}) => (
  <ChartCard
    isPending={isPending}
    isEmpty={!size(data)}
    title={title}
    emptyTitle={emptyTitle}
  >
    <AutoSizer>
      {({ width, height }) => (
        <PieChart
          width={width}
          height={height}
          data={data}
          margin={{ top: 15, bottom: 0, left: 15, right: 15 }}
        >
          <Tooltip content={<TooltipRenderer />} />

          <Legend
            layout="vertical"
            iconSize={17}
            verticalAlign="middle"
            align="right"
          />

          <Pie
            isAnimationActive={false}
            dataKey="value"
            nameKey="label"
            data={data}
            fill={fill}
          />
        </PieChart>
      )}
    </AutoSizer>
  </ChartCard>
);

export default PieChartCard;
